import { render, staticRenderFns } from "./AddressAutocompleteModal.vue?vue&type=template&id=b5135fd6"
import script from "./AddressAutocompleteModal.vue?vue&type=script&lang=js"
export * from "./AddressAutocompleteModal.vue?vue&type=script&lang=js"
import style0 from "./AddressAutocompleteModal.vue?vue&type=style&index=0&id=b5135fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports